import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

// Définir la mutation GraphQL
const ADD_USER_FROM_PROSPECT = gql`
  mutation TranferUserFromProspeect(
    $prospectUuid: ID!, 
    $email: String!, 
    $role: String!, 
    $consultantProfileUuid: ID!, 
    $language: InterfaceLanguage!, 
    $entryDate: Date!, 
    $iban: String, 
    $bicCode: String, 
    $retributionModelUuid: ID
  ) {
    addUserFromProspect(
      newUser: {
        prospectUuid: $prospectUuid,
        email: $email,
        role: $role,
        consultantProfileUuid: $consultantProfileUuid,
        language: $language,
        entryDate: $entryDate,
        iban: $iban,
        bicCode: $bicCode,
        retributionModelUuid: $retributionModelUuid
      }
    ) {
      uuid
    }
  }
`;

// Créer le hook personnalisé
export const useAddUserFromProspect = () => {
    const [addUserFromProspect, { data, loading, error }] = useMutation(ADD_USER_FROM_PROSPECT, {
    });

    const addNewUserFromProspect = async (newUserData) => {
        const {
            prospectUuid: prospectUuid,
            email: email,
            role: role,
            profile: consultantProfileUuid,
            language: language,
            entryDate: entryDate,
            iban: iban,
            bic: bicCode,
            retribution: retributionModelUuid
        } = newUserData;

        // Validation des champs obligatoires
        if (!prospectUuid || !email || !role || !consultantProfileUuid || !language || !entryDate) {
            throw new Error("Missing required fields: prospectUuid, email, role, consultantProfileUuid, language, or entryDate");
        }

        try {
            const result = await addUserFromProspect({
                variables: {
                    prospectUuid,
                    email,
                    role,
                    consultantProfileUuid,
                    language,
                    entryDate,
                    iban,
                    bicCode,
                    retributionModelUuid
                }
            });

            return {uuid : result.data.addUserFromProspect.uuid};
        } catch (e) {
            console.error("useAddUserFromProspect Error adding new user from prospect:", e.message);
            return { error: e.message };
        }
    };

    return { addNewUserFromProspect, data, loading, error };
};

export default useAddUserFromProspect;
